module.exports = __webpack_public_path__ + "img/8.2cbefd9b.jpg";